module.exports = __webpack_public_path__ + "img/12fc8eb.png";